<template>
  <v-container fluid class="container">
    <v-row class="d-flex justify-center">
      <v-spacer></v-spacer>
      <v-col cols="12" class="d-flex flex-column justify-center align-center text-center mt-16">
        <p
        :class="{'text-h2 font-weight-bold': $vuetify.display.mdAndUp, 'text-h3 font-weight-bold': $vuetify.display.smAndDown}">
          Unify Data, Models, &amp; Drawings in <span class="text-primary">Ellipse</span>
        </p>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <v-container>
      <v-img
        lazy-src="../assets/imgs/heroImage.gif"
        class ="responsive-img"
        src="../assets/imgs/heroImage.gif"
        contain
      ></v-img>
    </v-container>

    <v-container class="justify-center align-center mt-12">
      <v-col cols="12" class="d-flex flex-column justify-center align-center text-center">
        <p class="text-h4 font-weight-bold mb-6 mt-6">
            Create your first <span class="text-primary">Ellipse</span> Notebook Today
        </p>
        <v-btn color="primary" size="x-large" class="mt-4" @click="signUp">Get Started For Free</v-btn>
      </v-col>
    </v-container>


    
    <!-- Explore Solutions with Ellipse -->
    <v-container class="justify-center align-center mt-12">
  
      <!-- Section Title -->
      <v-row class="justify-center text-center mb-6 mt-6">
        <v-col cols="12">
          <p :class="{'text-h2 font-weight-bold': $vuetify.display.mdAndUp, 'text-h3 font-weight-bold': $vuetify.display.smAndDown}">
            Explore Solutions In <span class="text-primary">Ellipse</span></p>
        </v-col>
      </v-row>

      <!-- Dynamic Content Sections -->
      <v-row
        v-for="(item, index) in solutions"
        :key="index"
        class="d-flex align-center justify-center mt-16 mb-16"
        :class="index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'"
      >

        <!-- Image Column (Alternates Left & Right) -->
        <v-col cols="12" md="6" class="d-flex justify-center pr-4 pl-4">
          <v-img 
          :src="item.image" 
          contain 
          class="rounded-lg shadow responsive-img"
          width="100%"
          ></v-img>
        </v-col>

        <!-- Text Column -->
        <v-col cols="12" md="5" class="d-flex flex-column justify-center text-center text-md-left ml-4 mr-4">
          <h3 :class="{'text-h4 font-weight-bold mb-4 mt-4': $vuetify.display.mdAndUp, 'text-h5 font-weight-bold mb-4 mt-4': $vuetify.display.smAndDown}">{{ item.title }}</h3>
          <p :class="{'text-h5 text-darkgrey mb-4 mt-4': $vuetify.display.mdAndUp, 'text-h6 text-darkgrey mb-4 mt-4': $vuetify.display.smAndDown}">
            {{ item.description }}
          </p>
        </v-col>

      </v-row>
    </v-container>

    <!-- Clickable, automatic scroll Tabs -->
    <v-container class="justify-center align-center mt-16 mb-16">
  
      <v-row class="justify-center text-center mb-12">
        <v-col cols="12">
          <p :class="{'text-h2 font-weight-bold': $vuetify.display.mdAndUp, 'text-h3 font-weight-bold': $vuetify.display.smAndDown}">
            <span class="text-primary">Ellipse:</span> Your AEC Data Studio</p>
        </v-col>
      </v-row>

      <!-- Tabs Navigation -->
      <v-tabs 
        v-model="tab"
        bg-color="white"
        align-tabs="center"
        grow
        show-arrows
        :prev-icon="icons.arrowLeft"
        :next-icon="icons.arrowRight"
        class="custom-tabs"
      >
        <v-tab
          v-for="(item, index) in contentItems"
          :key="index"
          class="text-h5 font-weight-bold custom-tab v-tab"
          :value="item.value"
        >
          {{ item.title }}
        </v-tab>
      </v-tabs>

      <!-- Divider Line Below Tabs -->
      <div class="tabs-divider"></div>

      <!-- Tab Content -->
      <v-tabs-window v-model="tab" class="mt-12 mb-12">
        <v-tabs-window-item
          v-for="(item, index) in contentItems"
          :key="index"
          :value="item.value"
        >
          <v-row class="d-flex align-center justify-center mt-8" :class="index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'">
            
            <!-- Text Content -->
            <v-col cols="12" md="4" class="text-center text-md-left ml-12 mr-12">
              <p class="text-h6 text-darkgrey text-justify mb-12">
                {{ item.description }}
              </p>
            </v-col>

            <!-- Image Section -->
            <v-col cols="12" md="5" class="d-flex justify-center ml-12 mr-12">
              <v-img :src="item.image" contain class="responsive-img" width="100%"></v-img>
            </v-col>

          </v-row>
        </v-tabs-window-item>
      </v-tabs-window>
    </v-container>


    <!-- Avatars -->
    <v-container class="d-flex flex-column justify-center align-center mt-12">
      <div class="mt-12 mb-12 text-center">
        <p :class="{'text-h2 font-weight-bold': $vuetify.display.mdAndUp, 'text-h3 font-weight-bold': $vuetify.display.smAndDown}">Create Custom Project Dashboards</p>
      </div>

      <v-img
        class="elevated-img mt-6 mx-auto mb-12"
        width="100%"
        cover
        src="@/assets/imgs/customDashboards.png"
      />

      <v-row justify="center">
        <v-col 
          v-for="(item, index) in avatars"
          :key="index"
          cols="12" sm="6" md="4" lg="3"
          class="d-flex flex-column align-center mt-10"
        >
          <v-avatar size="80" color="white">
            <v-icon size="45" class="elevated-icon" color="grey">{{ item.icon }}</v-icon>
          </v-avatar>
          <div class="text-darkgrey mt-4 text-center">
            <p class="text-h5 font-weight-bold">{{ item.label }}</p>
          </div>
          <div class="text-darkgrey mt-2 mb-12 text-center description">
            <p :class="{'h6': $vuetify.display.mdAndUp, 'h6': $vuetify.display.smAndDown}">{{ item.description }}</p>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="mt-16">
      <v-row class="d-flex align-center justify-center position-relative mt-12 mb-12">

        <v-col cols="12" md="5" class="d-flex flex-column justify-center align-center text-center">
          <p class="text-h5 font-weight-bold mb-6">
            Create your first <span class="text-primary">Ellipse</span> Notebook Today
          </p>
          <v-btn color="primary" size="x-large" class="mb-6" @click="signUp">Get Started For Free</v-btn>
        </v-col>

        <!-- Divider-->
        <v-col cols="12" md="1" class="d-flex justify-center align-center">
          <div class="divider"></div>
        </v-col>

        <v-col cols="12" md="5" class="d-flex flex-column justify-center align-center text-center">
          <p class="text-h5 font-weight-bold mb-6">
            Check out <span class="text-primary">Ellipse</span> YouTube Tutorials
          </p>
          <v-btn color="primary" size="x-large" href="https://www.youtube.com/watch?v=_EKz710UGAw&ntb=1&msockid=8a4698750c1411f084cab1d3ba0010e6" target="_blank" rel="noopener">Learn Now</v-btn>
        </v-col>

      </v-row>
    </v-container>

    <v-container class="mb-6">
      <v-row class="d-flex align-center justify-center mt-6 mb-6">

        <!-- Left: Text Section -->
        <v-col cols="12" class="d-flex flex-column justify-center text-center">
          <p :class="{'text-h4 font-weight-bold mb-6': $vuetify.display.mdAndUp, 'text-h5 font-weight-bold mb-4': $vuetify.display.smAndDown}">
            Thank you for your interest in <span class="text-primary">Ellipse!</span>
          </p>
          <!--
          <p :class="{'text-h5 font-weight-bold mb-4': $vuetify.display.mdAndUp, 'text-h6 font-weight-bold mb-4': $vuetify.display.smAndDown}">
            This application is currently a <span class="text-primary"><i>Free Public Alpha.</i></span>
          </p>
          -->

        <!-- Right: Call-to-Action-->
          <p class="text-h6 text-grey">
            Ellipse is currently in alpha and under active development. You’re welcome to sign up and explore all features as they’re released. 
            Things may change frequently during this phase, and we truly appreciate your feedback as we continue to improve the experience.
          </p>
        </v-col>
      </v-row>
    </v-container>

    <v-footer class="footer-section">
    <v-container>
      <v-row class="justify-center text-center">
        <!-- Contact Header -->
        <v-col cols="12">
          <p :class="{'text-h3 font-weight-bold mb-6': $vuetify.display.mdAndUp, 'text-h4 font-weight-bold mb-6': $vuetify.display.smAndDown}">Contact Us</p>
        </v-col>

        <!-- Contact Description -->
        <v-col cols="12">
          <p class="text-h5 text-darkgrey mb-8">
            Want to learn more about <b class="text-primary">Ellipse</b>?
          </p>
        </v-col>

        <!-- Social Buttons -->
        <v-col cols="12" md="8" class="d-flex justify-center flex-wrap mb-8">
          <v-btn color="primary" variant="outlined" class="mx-2 mb-2" href="mailto:core@thorntontomasetti.com">
            <v-icon size="small" class="mr-2">{{ icons.contact }}</v-icon>Email
          </v-btn>
          <!--
          <v-btn color="primary" variant="outlined" class="mx-2 mb-2" href="https://twitter.com/tt_core">
            <v-icon size="small" class="mr-2">{{ icons.twitter }}</v-icon>Twitter
          </v-btn>
          -->
          <v-btn color="primary" variant="outlined" class="mx-2 mb-2" href="https://www.instagram.com/tt_corestudio/">
            <v-icon size="small" class="mr-2">{{ icons.instagram }}</v-icon>Instagram
          </v-btn>
          <v-btn color="primary" variant="outlined" class="mx-2 mb-2" href="https://www.linkedin.com/company/core-studio-tt">
            <v-icon size="small" class="mr-2">{{ icons.linkedIn }}</v-icon>LinkedIn
          </v-btn>
        </v-col>

        <!-- Email Info -->
        <v-col cols="12">
          <p class="text-h6">Email us at: 
            <a class="contact-email" href="mailto:ttcorestudio@gmail.com.">ttcorestudio@gmail.com.</a>
          </p>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
    
  </v-container>
</template>

<script>
import bus from "../plugins/bus";
import * as icons from "@/utilities/EllipseIcons.js";
import * as lexicon from "@/utilities/EllipseLexicon.js";

export default {
  setup() {
    return{
      icons,
      lexicon,
    };
  },
  data() {
    return {
      alert:true,
      colors: ["darkGrey", "darkGrey", "darkGrey"],
      slides: ["First", "Second", "Third"],
      solutions: [
        {
          title: "Investigate BIM Data",
          description:
            "Enjoy better, faster, and lightweight performance with a intuitive UI that makes data exploration effortless, even without in-depth BIM knowledge.",
          image: require('@/assets/imgs/investigateBIM.png'),
        },
        {
          title: "Grasshopper Optioneering",
          description:
            "Quickly find and optimize the best design options through an intuitive, performance-driven platform built for seamless exploration",
          image: require('@/assets/imgs/optioneering.gif'),
        },
        {
          title: "Drawing Review",
          description:
            "Enables efficient visualizations and easy access to underlying data. Extract key information, add comments, and collaborate effortlessly—all in one place.",
          image: require('@/assets/imgs/drawingReview.gif'),
        },
      ],
      contentItems: [
        {
          value: "one",
          title: "Integrate",
          description:
            "Assemble 3D models and 2D drawings with BIM project data sourced from software and databases for fully cross-connected interaction.",
          image: require('@/assets/imgs/Integrated_Artwork.png'),
        },
        {
          value: "two",
          title: "Explore",
          description:
            "Filter, query, compare, and analyze project data with its associated 2D and 3D representations to unlock project insights and graphically communicate value through intuitive data visualization.",
          image: require('@/assets/imgs/Explore_Artwork.png'),
        },
        {
          value: "three",
          title: "Curate",
          description:
            "Build a custom site with analytic dashboards, interactive tools, and dynamic presentations to tell your unique project story for each audience.",
          image: require('@/assets/imgs/Curate_Artwork.png'),
        },
        {
          value: "four",
          title: "Collaborate",
          description:
            "Bring teams together to help build a project, create their own pages, contribute through comments, or just view a presentation—you control access.",
          image: require('@/assets/imgs/Collaborate_Artwork.png'),
        },
      ],
      avatars: [
        {icon: this.lexicon.model.icon, label: "Visualize", description: "Interact with 2d, 3d, BIM data sets, images, maps and files all at once."},
        {icon: icons.graph, label: "Graphs", description: "Render dynamic charts for project data trends and relationships effectively"},
        {icon: this.lexicon.filter.icon, label: "Filters", description: "Set boundaries and conditions on data sets and filter by selection criteria in dashboards"},
        {icon: icons.search, label: "Quantitative Analysis", description: "Extract insights such as mean, median, mode, element counts, which can help cost evaluations."},
        {icon: this.lexicon.comment.icon, label: "Annotate", description: "Let team members rate and comment on custom dashboards and integrate results into your data set."},
        {icon: this.lexicon.layout.icon, label: "Custom Style", description: "Allows you to add logos, text, and colors to align projects with your brand."},
        {icon: icons.save, label: "Templates", description: "Save your custom dashboards as templates to re-use or share with teams."},
        {icon: this.lexicon.mention.icon, label: "Collaborate", description: "Share notebooks, layouts and templates across teams for streamlined workflows"},
      ],
      tab: "one",
      tabItems: [
        {
          value: "one",
          label: "Centralized Project Hub",
          tagLine: "No more scattered files, everything in one place.",
          description:
            "Ellipse provides a single, unified space where all project data, 3D models, documents, and design files are stored securely. Instead of switching between multiple platforms, spreadsheets, and local drives, everything you need is in one cloud-based hub.",
          keyFeature1: "Integrated 3D Model & Data Management – Link geometry with structured data for enhanced analysis.",
          keyFeature2: "Advanced Search & Filtering – Quickly find files, models, or datasets with intelligent search.",
          image: require('@/assets/imgs/placeholderImage.png'),
        },
        {
          value: "two",
          label: "Accessible Anywhere",
          tagLine: "A web-based platform that works across all devices and locations.",
          description:
            "Ellipse is cloud-native, meaning it works on any device with a web browser—desktop, tablet, or smartphone. Whether you’re in the office, on-site, or working remotely, your projects are instantly accessible without the need for installations or heavy downloads.",
          keyFeature1: "Device-Agnostic Access – Works seamlessly on Windows, Mac, iOS, and Android.",
          keyFeature2: "Zero Installation Required – No software downloads; just log in and start working.",
          image: require('@/assets/imgs/placeholderImage.png'),
        },
        {
          value: "three",
          label: "Real-Time Collaboration",
          tagLine: "Work with your team simultaneously on shared projects.",
          description:
            "Ellipse makes teamwork effortless by allowing multiple users to view, edit, and comment on models and documents in real time. Forget email chains and delayed feedback—collaborate live with built-in communication tools.",
          keyFeature1: "Commenting & Annotations – Leave contextual feedback directly on models or documents.",
          keyFeature2: "Role-Based Permissions – Control access for team members, clients, and collaborators",
          image: require('@/assets/imgs/placeholderImage.png'),
        },
        {
          value: "four",
          label: "Fast & Lightweight",
          tagLine: "Optimized for performance without compromising features.",
          description:
            "Ellipse is designed to handle large 3D models, complex data, and multi-user collaboration while maintaining high performance and speed. Unlike traditional software that requires heavy installations, Ellipse runs smoothly in the cloud with optimized rendering and data processing.",
          keyFeature1: "Cloud-Based Performance Optimization – Handles large datasets with minimal lag.",
          keyFeature2: "Efficient 3D Rendering – Optimized for web-based visualization without loss of detail",
          image: require('@/assets/imgs/placeholderImage.png'),
        },
      ],
      socials:[
        {icon: icons.linkedin},
        {icon: icons.instagram},
        {icon: icons.twitter},
      ],
    };
  },
  created() {
    //bus.on("my_little_start_event", ()=>{console.error("my_little_start_event")});
  },
  mounted() {
    //bus.emit("my_little_start_event");
  },
  methods: {
    signUp() {
      this.$auth.loginWithRedirect({ screen_hint: "signup" });
    },
  },
};
</script>

<style scoped>
.container {
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  padding: 0 20px; /* default padding */
}

@media (min-width: 600px) {
  .container {
    max-width: 90%; /* For screen sizes above 600px */
    padding: 0 30px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 1100px; /* For screen sizes above 768px */
    padding: 0 40px;
  }
}

@media (min-width: 1024px) {
  .container {
    max-width: 1200px; /* For screen sizes above 1024px */
    padding: 0 50px;
  }
}

@media (min-width: 1440px) {
  .container {
    max-width: 1300px; /* For screen sizes above 1440px */
    padding: 0 60px;
  }
}

/* Responsive Image */
.responsive-img {
  height: 90%;
}

@media (min-width: 1024px) {
  .responsive-img {
    height: 50%;
  }
}

/* Responsive Avatar & Icon */
.responsive-avatar {
  width: 100px;
  height: 100px;
}
.responsive-icon {
  font-size: 45px;
}

@media (max-width: 960px) {
  .responsive-avatar {
    width: 80px;
    height: 80px;
  }
  .responsive-icon {
    font-size: 35px;
  }
}

@media (max-width: 600px) {
  .responsive-avatar {
    width: 60px;
    height: 60px;
  }
  .responsive-icon {
    font-size: 25px;
  }
}
.v-btn {
  font-size: 20px;
}
.bordered-img {
  border: 1px solid #000000;
  border-radius: 10px;
  align-content: center;
}
.elevated-img {
  border-radius: 8px;
  box-shadow: 0 5px 10px rgba(225, 209, 255, 0.25);
}
.elevated-icon {
  filter: drop-shadow(2px 4px 4px rgba(0, 0, 0, 0.3));
}

.gradient-background {
  border-radius: 20px;
  background: radial-gradient(circle at top left, rgba(255, 255, 255, 0.9), rgba(176, 176, 255, 0.5)),
              radial-gradient(circle at bottom right, rgba(218, 228, 255, 0.6), rgba(255, 255, 255, 0.8));
}
.solid-border {
  border: 1px solid #d4a7ff;
  border-radius: 20px;
}
.border-fillet {
  border-radius: 20px;
}
.description {
  white-space: normal;
  word-wrap: break-word;
  max-width: 70%;
}
.v-tabs {
  background-color: #f5f5f5;
}
.v-tab-item {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}
.glow-container {
  box-shadow: 0px 0px 20px rgba(177, 176, 255, 0.5);
  border-radius: 12px;
}
.container-hover-effect {
  transition: all 0.3s ease-in-out;
}
.container-hover-effect:hover {
  transform: scale(1.02);
  box-shadow: 0px 10px 40px rgba(160, 150, 255, 0.425);
}
.divider {
  position: absolute;
  left: 50%;
  top: 10%;
  bottom: 10%;
  width: 4px;
  background: linear-gradient(to bottom, #3700ff, #5f5cff, #b09fff);
  border-radius: 2px;
}
@media (max-width: 960px) {
  .divider {
    display: none;
  }
}
.custom-tabs .v-tab {
  position: relative;
  padding-bottom: 12px;
}
@media (max-width: 600px) { 
  .custom-tabs .v-tab {
    flex: 1 1 100%; /* Each tab takes full width */
    max-width: 100%;
    text-align: center;
  }
}
.custom-tab {
  color: black;
  transition: color 0.3s ease-in-out;
}
.custom-tab.v-tab--selected {
  color: #6200ea !important;
  font-weight: bold;
}
.custom-tab.v-tab--selected::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 50%;
  height: 4px;
  background: #6200ea;
  border-radius: 4px;
  transform: translateX(-50%);
  transition: width 0.3s ease-in-out;
  box-shadow: 0px 0px 12px rgba(98, 0, 234, 0.6);
}
.custom-tab:hover {
  color: #7c4dff !important;
}
.tabs-divider {
  width: 100%;
  height: 2px;
  background-color: rgba(0, 0, 0, 0.1);
  margin-top: -2px;
}
.footer-section {
  background-color: white;
  padding: 40px 0;
  border-top: 2px solid rgba(0, 0, 0, 0.1); /* Subtle top border */
}

.contact-email {
  color: rgb(var(--v-theme-primary));
  font-weight: bold;
  text-decoration: none;
}

.contact-email:hover {
  text-decoration: underline;
}
</style>
